"use strict";

var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../../../../components/media/icon/Icon");
var _BaseColumn = require("../../../../components/data-display/table/column/support/BaseColumn");
var _Text = _interopRequireDefault(require("../../../../components/text/Text"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
var ClickableIcon = (0, _styledComponents.default)(_Icon.Icon).withConfig({
  displayName: "IconColumn__ClickableIcon",
  componentId: "sc-sacq0b-0"
})(["cursor:pointer;"]);
var IconColumn = function IconColumn(_) {
  return null;
};
IconColumn.toColumnDef = function (child) {
  var _child$props = child.props,
    accessorKey = _child$props.accessorKey,
    icon = _child$props.icon,
    _onClick = _child$props.onClick;
  var getLabel = function getLabel(value) {
    var _icon;
    return (_icon = icon(value)) === null || _icon === void 0 ? void 0 : _icon.label;
  };
  return _objectSpread({}, (0, _BaseColumn.defaultColumnDef)(child.props, getLabel), {
    accessorKey: accessorKey,
    cell: function cell(_ref) {
      var row = _ref.row,
        getValue = _ref.getValue;
      var iconProperties = icon(getValue());
      if (iconProperties) {
        var label = iconProperties.label,
          _icon2 = _objectWithoutProperties(iconProperties, ["label"]);
        return (0, _BaseColumn.styledCell)(child.props, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [!!label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            size: '2',
            children: label
          }), _onClick ? /*#__PURE__*/(0, _jsxRuntime.jsx)(ClickableIcon, _objectSpread({}, _icon2, {
            onClick: function onClick() {
              return _onClick(row.original);
            }
          })) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread({}, _icon2))]
        }));
      }
      return null;
    }
  });
};
var _default = exports.default = IconColumn;